<div
  class="app-checkbox-field"
  [class.app-checkbox-field--checked]="checked"
  [class.app-checkbox-field--disabled]="disabled"
  (click)="onClick($event)"
>
  <lib-icon
    *ngIf="checked"
    icon="check"
    [inline]="true"
    class="app-checkbox-field-check"
  ></lib-icon>
</div>
